import { createSelector } from 'reselect'

const getUserLevelType = state => state.user.data.userAcademicLevel

const getUserAcademicLevel = createSelector(
	[ getUserLevelType],
	userLevelType => userLevelType
)

export default getUserAcademicLevel
